module.exports = __webpack_public_path__ + "img/04.6ab2b937.jpg";